import React from "react";
import { useFormContext } from "react-hook-form";

import { SelectField, TextField } from "components/AddVaccineForm/components";
import { IntlPhoneField } from "components/form/IntlPhoneField/IntlPhoneField";

import s from "../PatientProfileForm.module.css";
import {
  LABEL_HOME_PHONE,
  LABEL_MOBILE_PHONE,
  PHONE_PLACEHOLDER_HOME,
  PHONE_PLACEHOLDER_MOBILE,
} from "../utils/patientProfileFormDefaults";

export function PatientProfileContactSection({
  isCreate,
  nextOfKinRelationshipSelectOptions,
}) {
  const { setValue } = useFormContext();
  const sectionClass = isCreate ? s.sectionCreate : s.sectionEdit;
  const headerClass = isCreate ? s.sectionHeader : s.sectionHeaderEdit;

  return (
    <div className={sectionClass}>
      <h3 className={headerClass}>Contact and Next of kin</h3>
      <div className={s.formGrid}>
        <IntlPhoneField
          name="mobilePhone"
          label={LABEL_MOBILE_PHONE}
          placeholder={PHONE_PLACEHOLDER_MOBILE}
          ariaRequired
        />
        <IntlPhoneField
          name="homePhone"
          label={LABEL_HOME_PHONE}
          placeholder={PHONE_PLACEHOLDER_HOME}
        />
        <TextField
          name="email"
          label="Email"
          type="email"
          placeholder="Enter email"
        />
        <TextField
          name="nextOfKin"
          label="Next of kin name"
          placeholder="Enter next of kin name"
        />
        <SelectField
          name="nextOfKinRelationship"
          label="Next of kin relationship"
          options={nextOfKinRelationshipSelectOptions}
          placeholder="Select"
          onChange={(value) => {
            setValue("nextOfKinRelationship", value);
          }}
        />
        <IntlPhoneField
          name="nextOfKinPhone"
          label="Next of kin phone"
          placeholder={PHONE_PLACEHOLDER_HOME}
        />
      </div>
    </div>
  );
}
